









































































import { AccessRoleTypes, UUID } from "@/data/enums";
import { Vue, Component, Inject, Prop } from "vue-property-decorator";
import {
  ITimelineMappedEvent,
  ITimelineProvider,
  ITimelineProviderMethods
} from "@/models/providers/timeline";
import { IUser } from "@/models/users";

@Component
export default class TimelineEventMessage extends Vue {
  // Injected
  @Inject({ from: "timelineProviderMethods" })
  public readonly $timelineMethods!: ITimelineProviderMethods;

  @Inject({ from: "timelineProvider" })
  public readonly $timelineData!: () => ITimelineProvider;

  // Props
  @Prop({ required: true })
  public event!: ITimelineMappedEvent;

  // Getters
  public get timelineData() {
    return this.$timelineData();
  }

  public get isClientActor() {
    return (
      this.$_.get(this.event, "sourceEvent.access_role") ===
      AccessRoleTypes.CLIENT
    );
  }

  public get isUpmindStaffActor() {
    return (
      this.event?.sourceEvent?.access_role === AccessRoleTypes.USER &&
      this.event?.sourceEvent?.actor?.org_id === UUID.SYS
    );
  }

  public get isStaffUserActor() {
    return (
      this.event?.sourceEvent?.access_role === AccessRoleTypes.USER &&
      this.event?.sourceEvent?.object?.user_id !== UUID.SYS
    );
  }

  public get isSystemActor() {
    return this.event?.sourceEvent?.access_user_id === UUID.SYS;
  }

  public get isApiActor() {
    return (
      this.event?.sourceEvent?.access_role === AccessRoleTypes.USER &&
      (this.event?.sourceEvent?.actor as IUser)?.api_user
    );
  }

  public get isSameActorContext() {
    return this.timelineData.userId === this.$_.get(this.event, "actor.id");
  }

  public get isSameContext() {
    return (
      this.timelineData.type === this.event.object_type &&
      this.timelineData.objectId === this.event.object_id
    );
  }

  public onClick(e, event) {
    // Prevent linking to/ opening views/modals if we are in the same context i.e we are looking at the invoice, client etc
    if (this.isSameContext && e) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return;
    }
    if (event.onClick && e) {
      e.stopImmediatePropagation();
      e.preventDefault();
      event.onClick(event);
    }
  }
}
